import React from 'react';
import PreloadGenerator from '../../../components/preload-generator';

const PreloadGeneratorPage = () => {
  return <PreloadGenerator />;
};

export default PreloadGeneratorPage;
